export default "__VITE_ASSET__5KfNHlGh__"